import Login from '@/components/Security/login'
import Logout from '@/components/Security/logout'
import Profile from '@/components/Security/profile'
import SecurityResetPassword from '@/components/Security/reset_password'
import SecurityChangePassword from '@/components/Security/change_password'
import SecurityResetPasswordAsk from '@/components/Security/reset_password_ask'

let SecurityRouter = [{
  path: '/security/login',
  name: 'Login',
  component: Login
}, {
  path: '/security/profile',
  name: 'Profile',
  component: Profile
}, {
  path: '/security/logout',
  name: 'Logout',
  component: Logout
},  {
  path: '/security/change_password',
  name: 'SecurityChangePassword',
  component: SecurityChangePassword
},   {
  path: '/security/reset_password',
  name: 'SecurityResetPasswordAsk',
  component: SecurityResetPasswordAsk
}, {
  path: '/security/reset_password/:token',
  name: 'SecurityResetPassword',
  component: SecurityResetPassword
}]

export default SecurityRouter


// WEBPACK FOOTER //
// ./src/components/Security/router.js